import { createContext, useContext, useState } from "react";
import { content } from "../data/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const t = content[lang];
  const toggle = () => setLang((l) => (l === "it" ? "en" : "it"));
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
